import { jsx as _jsx } from "react/jsx-runtime";
/** React context that exposes the per-panel ResourceLoader to descendants, provided by `<TscnPreviewShell>`. */
import { createContext } from 'react';
/**
 * Frames a load's consumers take to commit after the loader settles. They commit within a render
 * or two of its last event, so ten cover them with room to spare.
 */
export const COMMIT_FRAMES_AFTER_SETTLE = 10;
/** `null` until a loader is mounted. */
export const ResourceLoaderContext = createContext(null);
export function ResourceLoaderProvider({ loader, children }) {
    return _jsx(ResourceLoaderContext.Provider, { value: loader, children: children });
}
//# sourceMappingURL=ResourceLoaderContext.js.map